<template>
  <section>
    <div v-if="loading">
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
          <a
            data-target="#create-modal"
            data-toggle="modal"
            class="button text-white bg-theme-1 shadow-md mr-2"
            >Crear Cliente</a
          >
        </div>
      </div>
      <!-- END: Filter -->

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Editar Cliente</h2>
        </div>
        <form @submit.prevent="updateEditElement">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-4">
              <label>Razon Social*</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.social_reason"
                required
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Nit*</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.nit"
                required
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Pais</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="client_current.country_id"
                required
              >
                <option seleted :value="null">Seleccione el país</option>
                <option
                  v-for="country in countries"
                  :value="country.id"
                  :key="`country-${country.id}`"
                >
                  {{ country.name }}
                </option>
              </select>
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Direccion</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.address"
              />
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Telefono fijo</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.telphone"
              />
            </div>
            <div class="col-span-12 sm:col-span-12">
              <div
                class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
              >
                <h3 class="font-medium text-base mr-auto">Contacto Compras</h3>
              </div>
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Nombre</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.contact_purchasing"
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Celular</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.cellphone_purchasing"
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Email</label>
              <input
                type="email"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.email_purchasing"
              />
            </div>
            <div class="col-span-12 sm:col-span-12">
              <div
                class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
              >
                <h3 class="font-medium text-base mr-auto">
                  Contacto Tesoreria
                </h3>
              </div>
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Nombre</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.contact_treasury"
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Celular</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.cellphone_treasury"
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Email</label>
              <input
                type="email"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.email_treasury"
              />
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Link</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client_current.link"
              />
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              @click="closeEditElement()"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="create"
            >
              Modificar
            </button>
          </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- List -->
      <div class="overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="text-center whitespace-no-wrap">RAZON SOCIAL</th>
              <th class="text-center whitespace-no-wrap">NIT</th>
              <th class="text-center whitespace-no-wrap">PAIS</th>
              <th class="text-center whitespace-no-wrap">URL</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="intro-x"
              v-for="client in clients"
              :key="`client-${client.id}`"
            >
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ client.social_reason | limit }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ client.nit }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ client.country.name }}
                </div>
              </td>
              <td class="w-40 text-center">
                <a
                  :href="client.link"
                  class="font-medium whitespace-no-wrap"
                  target="_blank"
                  v-if="client.link"
                  >link</a
                >
              </td>
              <td class="table-report__action w-56">
                <div class="flex justify-center items-center">
                  <router-link
                    :to="`/admin/business/clients/relations/${client.id}`"
                    class="pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in"
                  >
                    {{ client.accounts.length }}
                    <app-icon name="folder" classname="w-4 h-4 mr-2"></app-icon>
                  </router-link>
                  <button
                    @click="editElement(client)"
                    class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon name="edit" classname="w-4 h-4 mr-2"></app-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
    </div>

    <app-loading v-else></app-loading>

    <!-- Modal -->
    <div class="modal" id="create-modal">
      <div class="modal__content modal__content--xl">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
        >
          <h2 class="font-medium text-base mr-auto">Crear Cliente</h2>
        </div>
        <form
          @submit.prevent="createElement"
          enctype="multipart/form-data"
          class="form-task"
        >
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-4">
              <label>Razon Social*</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client.social_reason"
                required
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Nit*</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client.nit"
                required
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Pais</label>
              <select
                class="input w-full border mt-2 flex-1"
                v-model="client.country_id"
                required
              >
                <option seleted value="null">Seleccione el país</option>
                <option
                  v-for="country in countries"
                  :value="country.id"
                  :key="`country-${country.id}`"
                >
                  {{ country.name }}
                </option>
              </select>
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Direccion</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client.address"
              />
            </div>
            <div class="col-span-12 sm:col-span-6">
              <label>Telefono fijo</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client.telphone"
              />
            </div>
            <div class="col-span-12 sm:col-span-12">
              <div
                class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
              >
                <h3 class="font-medium text-base mr-auto">Contacto Compras</h3>
              </div>
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Nombre</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client.contact_purchasing"
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Celular</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client.cellphone_purchasing"
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Email</label>
              <input
                type="email"
                class="input w-full border mt-2 flex-1"
                v-model="client.email_purchasing"
              />
            </div>
            <div class="col-span-12 sm:col-span-12">
              <div
                class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
              >
                <h3 class="font-medium text-base mr-auto">
                  Contacto Tesoreria
                </h3>
              </div>
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Nombre</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client.contact_treasury"
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Celular</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client.cellphone_treasury"
              />
            </div>
            <div class="col-span-12 sm:col-span-4">
              <label>Email</label>
              <input
                type="email"
                class="input w-full border mt-2 flex-1"
                v-model="client.email_treasury"
              />
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Link</label>
              <input
                type="text"
                class="input w-full border mt-2 flex-1"
                v-model="client.link"
              />
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
            <button
              type="button"
              data-dismiss="modal"
              class="button w-20 border text-gray-700 mr-1"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="button w-20 bg-theme-1 text-white"
              id="create"
            >
              Crear
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal End -->
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminListTask',
  data() {
    return {
      loading: false,
      boxedit: false,
      client: this.defineClient(),
      client_current: {},
    }
  },
  computed: {
    ...mapGetters({
      clients: 'getClients',
      countries: 'getAccountCountries',
    }),
  },
  mounted() {
    $('#create-modal').on('hidden.bs.modal', () => {
      this.defineClient()
    })
  },
  async beforeMount() {
    try {
      await this.getList('client')
      await this.getList('accountcountry')

      this.loading = true
    } catch (error) {}
  },
  methods: {
    defineClient() {
      return {
        social_reason: null,
        nit: null,
        address: null,
        telphone: null,
        contact_purchasing: null,
        cellphone_purchasing: null,
        email_purchasing: null,
        contact_treasury: null,
        cellphone_treasury: null,
        email_treasury: null,
        link: null,
        entity: 'client',
      }
    },
    createElement() {
      var vm = this
      window.$('#create').button('loading')
      vm.store(vm.client)
        .then((item) => {
          window.$('#create-modal').modal('hide')
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/business/clients'
          )
        })
        .catch((error) => {
          console.log('FAILURE!!')
        })
        .finally(() => {
          window.$('#create').button('reset')
          vm.loading = true
          this.client = this.defineClient()
        })
    },
    editElement(value) {
      this.boxedit = true
      this.client_current = JSON.parse(JSON.stringify(value))
    },
    closeEditElement() {
      this.boxedit = false
      this.client_current = {}
    },
    updateEditElement(value) {
      let vm = this
      vm.client_current.entity = 'client'
      vm.loading = false
      vm.update(vm.client_current)
        .then((item) => {
          vm.loading = true
          vm.boxedit = false
          vm.client = this.defineClient()
          vm.$router.replace(
            vm.$route.query.redirect || '/admin/business/clients'
          )
        })
        .catch((message) => {
          vm.loading = true
        })
    },
    ...mapActions(['getAll', 'getList', 'store', 'update']),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
  },
}
</script>



// WEBPACK FOOTER //
// ListClients.vue?c805112c